import { Box } from '@chakra-ui/react'
import React, { FC, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { DropdownOption, SortDropdown } from '~shared-components/components'
import { GLOBAL_SEARCH_PER_COUNTRY } from '~shared-components/components/FlagRender/frozenFlags'
import { ConfigSelector } from '~shared-components/redux/selectors/config.selector'

export interface SortPanelProps {
  children?: never
  defaultSortKey: string
  isInternal: boolean
  onSortKeyChanged?(sortKey: string): void
  options: DropdownOption[]
}
export const SortPanel: FC<SortPanelProps> = ({
  defaultSortKey,
  isInternal,
  onSortKeyChanged,
  options,
}) => {
  const country = useSelector(ConfigSelector.localeCountry)

  const [sortKey, setSortKey] = React.useState<string | undefined>(
    defaultSortKey,
  )
  const lastSortKey = useRef<string | undefined>(sortKey)

  useEffect(() => {
    if (lastSortKey.current !== sortKey) {
      lastSortKey.current = sortKey
      onSortKeyChanged?.(sortKey || defaultSortKey)
    }
  }, [sortKey, defaultSortKey, onSortKeyChanged])

  if (!Object.keys(options).length || !sortKey) return null

  if (isInternal || !GLOBAL_SEARCH_PER_COUNTRY[country]) return null

  return (
    <Box>
      <SortDropdown
        onOptionSelect={value => setSortKey(value)}
        options={options}
        value={sortKey}
      />
    </Box>
  )
}
SortPanel.displayName = 'ListPage.SortPanel'
